import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin-top: ${({ isMarginTop }) => (!isMarginTop ? "35px" : 0)};
`;
